import utils from "@/utils/comUtils.js";
import { userLimitHandler } from "../common-methods/utils.js";
import {
  BigWheelConstants as BWC,
  MsgDialogType
} from "./common/global-variable";
import {
  USER_LIMIT_STATUS,
  ActivityType
} from "../../../../commons/commonVariables.js";
import { Toast } from "vant";

const mixin = {
  data() {
    return {
      position: {
        lng: "",
        lat: ""
      } //经纬度
    };
  },
  methods: {
    getjumpText() {
      if (
        this.awardObj.jumpType === BWC.JumpType.voucherList ||
        this.awardObj.jumpType === BWC.JumpType.couponList
      ) {
        return "去使用";
      } else if (this.awardObj.jumpType === BWC.JumpType.MPIndex) {
        // 实物-线上邮寄
        if (
          this.awardObj.rewardType === BWC.GoodsType.entityAward &&
          this.awardObj.collectionType ===
            BWC.CollectionType.expressOrOnlineCheckOff
        ) {
          return this.getEntityAwardBtnText();
        }
        return "确认";
      } else if (this.awardObj.jumpType === BWC.JumpType.customLink) {
        // 实物-线上邮寄
        if (
          this.awardObj.rewardType === BWC.GoodsType.entityAward &&
          this.awardObj.collectionType ===
            BWC.CollectionType.expressOrOnlineCheckOff
        ) {
          return this.getEntityAwardBtnText();
        }
        // 门店自提
        if (
          this.awardObj.rewardType === BWC.GoodsType.entityAward &&
          this.awardObj.collectionType === BWC.CollectionType.inStore
        ) {
          return "确认";
        }
        // 积分
        if (this.awardObj.rewardType === BWC.GoodsType.accumulatePoints) {
          return "去使用";
        }
        return "下一步";
      } else if (this.awardObj.jumpType === BWC.JumpType.noJump) {
        // 实物-线上邮寄
        if (
          this.awardObj.rewardType === BWC.GoodsType.entityAward &&
          this.awardObj.collectionType ===
            BWC.CollectionType.expressOrOnlineCheckOff
        ) {
          return this.getEntityAwardBtnText();
        }
        // 到店自提，虚拟，线上核销,线上兑换
        if (
          ([BWC.GoodsType.virtualAward, BWC.GoodsType.entityAward].includes(
            this.awardObj.rewardType
          ) &&
            [
              BWC.CollectionType.inStore,
              BWC.CollectionType.checkOffStrCode
            ].includes(this.awardObj.collectionType)) ||
          (this.awardObj.rewardType === BWC.GoodsType.virtualAward &&
            this.awardObj.collectionType ===
              BWC.CollectionType.expressOrOnlineCheckOff)
        ) {
          return "确认";
        }
        if (
          this.awardObj.collectionType === BWC.CollectionType.freeOfCharge &&
          ["3", "4"].includes(this.awardObj.drawOrderSource)
        ) {
          return "确认";
        }
        return "我知道了";
      } else {
        return "我知道了";
      }
    },
    // 获取实物-线上邮寄的用户信息录入弹窗按钮文字
    getEntityAwardBtnText() {
      // 以下3种情况，实物-线上邮寄的用户信息录入弹窗按钮文字为“提交”，否则为“确认”
      if (
        [BWC.ActivityStatus.running, BWC.ActivityStatus.paused].includes(
          this.awardObj.activityStatus
        )
      ) {
        if (
          this.awardObj.extendConfigFlag === true &&
          this.awardObj.goodsOverdueFlag === false &&
          this.awardObj.hasLockedFlag === false
        ) {
          // 1、（活动进行中 或 活动已暂停） 且 用户已填写 且 权益品未过期 且 奖项未锁定
          return "提交";
        }
        if (this.awardObj.extendConfigFlag === false) {
          // 2、（活动进行中 或 活动已暂停） 且 用户未填写
          return "提交";
        }
        return "确认";
      } else if (
        this.awardObj.activityStatus === BWC.ActivityStatus.finished &&
        this.awardObj.extendConfigFlag === false
      ) {
        // 3、活动已结束 且 用户未填写
        return "提交";
      } else {
        return "确认";
      }
    },
    //打开分享引导提示
    openGuide() {
      this.$refs.guideModal.openModel();
    },
    // 埋码事件：抽奖动作
    handleDrawProcess(type) {
      let actionCode = "";
      let actionName = "";
      let title = "";
      let userId = ""; // 用户ID
      switch (type) {
        // 1.抽大转盘
        case "1":
          {
            actionCode = "400080009";
            actionName = "抽大转盘";
            title = "抽大转盘";
          }
          break;
        // 2.抽盲盒
        case "2":
          {
            actionCode = "400080010";
            actionName = "抽盲盒";
            title = "抽盲盒";
          }
          break;
        // 3.抽轮盘锦鲤
        case "3":
          {
            actionCode = "400080011";
            actionName = "抽轮盘锦鲤";
            title = "抽轮盘锦鲤";
          }
          break;
        // 4.抽新盲盒
        case "4":
          {
            actionCode = "400080012";
            actionName = "抽新盲盒";
            title = "抽新盲盒";
          }
          break;
        default:
          console.log("埋码活动类型不存在！");
      }

      // 如果用户ID来源于APKM，那么就对用户ID埋码
      if (this.from === "APKM" && this.userId) {
        userId = this.userId;
      }

      let params = {
        actionCode: actionCode,
        actionName: actionName,
        content: {
          title: title,
          channel:
            this.loginType == "none"
              ? "无需登陆"
              : this.loginType == "wechat"
              ? "微信"
              : "支付宝",
          activityCode: this.activityCode,
          experience_app_id: userId // 如果用户ID来源于APKM，那么就对用户ID埋码，若无则为空
        }
      };
      // 大转盘的几个场景中，如果session缓存中存在eventTrackingData，则将storeCode存入content中
      if (
        ["400080009", "400080010", "400080011", "400080012"].includes(
          params.actionCode
        )
      ) {
        const eventTrackingData = JSON.parse(
          sessionStorage.getItem("eventTrackingData")
        );
        if (eventTrackingData && eventTrackingData.storeCode) {
          params.content.channelCode = eventTrackingData.storeCode;
        }
      }
      const eventTrackingData = JSON.parse(
        sessionStorage.getItem("eventTrackingData") || "{}"
      );
      if (
        eventTrackingData &&
        eventTrackingData.storeCode &&
        eventTrackingData.guideUserId
      ) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      }
      utils.handleBatchReport(this, params);
    },
    // 埋码事件：抽奖结果
    handleClickResultAwardRotateProcess(award) {
      let userId = ""; // 用户ID
      const awardItem = {
        "0": "未中奖",
        "1": "虚拟奖品",
        "2": "实物奖品",
        "3": "优惠券奖品",
        "4": "积分奖品"
      };

      // 如果用户ID来源于APKM，那么就对用户ID埋码
      if (this.from === "APKM" && this.userId) {
        userId = this.userId;
      }

      let params = {
        actionCode: "400060002",
        actionName: "抽奖结果",
        content: {
          title: "大转盘抽奖结果",
          channel:
            this.loginType === "none"
              ? ""
              : this.loginType === BWC.LoginType.Wechat
              ? "微信"
              : "支付宝",
          shareType: this.shareType === "undefined" ? "" : this.shareType,
          awardType: awardItem[award.goodsType],
          awardName:
            award.goodsType === "3" ? award.activationCode : award.goodsName,
          activityCode: this.activityCode,
          experience_app_id: userId // 如果用户ID来源于APKM，那么就对用户ID埋码，若无则为空
        }
      };
      const eventTrackingDataNew = JSON.parse(
        sessionStorage.getItem("eventTrackingData") || "{}"
      );
      // 如果session缓存中存在eventTrackingData，则将storeCode存入content中
      if (eventTrackingDataNew && eventTrackingDataNew.storeCode) {
        params.content.channelCode = eventTrackingDataNew.storeCode;
      }
      if (
        eventTrackingDataNew &&
        eventTrackingDataNew.storeCode &&
        eventTrackingDataNew.guideUserId
      ) {
        params.content.activityName = eventTrackingDataNew.activityName;
        params.content.activityType = eventTrackingDataNew.activityType;
        params.content.guideUserId = eventTrackingDataNew.guideUserId;
        params.content.channelCode = eventTrackingDataNew.storeCode;
      }
      utils.handleBatchReport(this, params);
    },
    async noChance(msgText = "", dialogType = MsgDialogType.UtilsDialog) {
      if (
        this.loginType !== "none" &&
        this.isLoginFlag &&
        [
          USER_LIMIT_STATUS.QY_WECHAT_GUIDE_TIME_LIMIT,
          USER_LIMIT_STATUS.COMMUNITY_USER_TIME_LIMIT,
          USER_LIMIT_STATUS.JOIN_MEMBER_TIME_LIMIT,
          USER_LIMIT_STATUS.NOT_ADD_QY_WECHA_GUIDE_LIMIT,
          USER_LIMIT_STATUS.NOT_ADD_COMMUNITY_LIMIT
        ].includes(this.$parent.userLimitStatus) &&
        this.activityStatus === BWC.ActivityStatus.running
      ) {
        // 抽奖对象首先是会员，而且要登录状态，userLimitStatus为用户身份限制状态
        userLimitHandler(
          this.$parent.userLimitStatus,
          ActivityType.bigTurnable,
          this.activityObj.activityConfig,
          "children",
          this
        );
        return;
      }
      // 传入了提示语，则以传入的提示语为准，否则选择备用
      let message = msgText || "抽奖机会已用完";
      if (
        this.drawStatus === BWC.status.exceedDailyTimes ||
        this.drawStatus === BWC.status.exceedTotalTimes
      ) {
        message = this.tipsMessage || "";
      }
      // 根据弹窗类型进行提示
      if (dialogType === MsgDialogType.UtilsDialog) {
        this.$utils.tips.message("warning", message);
      } else {
        Toast(message);
      }
    },
    noPoints() {
      let message = `${this.poinsOrDiamonds}不足`;
      if (
        this.drawStatus === BWC.status.exceedDailyTimes ||
        this.drawStatus === BWC.status.exceedTotalTimes
      ) {
        message = this.tipsMessage || "";
      }
      this.$utils.tips.message("warning", message);
    },
    notStart() {
      this.$utils.tips.message("warning", "活动未开始！");
    },
    hasEnd() {
      this.$utils.tips.message("warning", "活动已结束！");
    },
    hasStop() {
      this.$utils.tips.message("warning", "活动已暂停！");
    }
  }
};

export default mixin;



// WEBPACK FOOTER //
// ./src/page/vibrantRubikCube/runtime/lucky-draw/mixin.js